module.exports = __webpack_public_path__ + "img/vote_example_login.292aa706.jpg";